module.exports = __webpack_public_path__ + "img/no_graph_data.08e40ce6.svg";